// Re-export types from the new asset type system for backward compatibility
export type {
  FilterState,
  FilterAction,
  FilterBehavior,
  FilterLogic,
  FilterConfig,
  FilterConfigs,
  FacetParent,
  FacetCount,
  SecondaryToggles,
  SecondaryToggle,
  ActivePrimaryToggle,
  CompatibilityType,
} from './assetTypes';

export { Compatibility } from './assetTypes';

/**
 * Scopes inline keyword suggestions to the content actually shown on a
 * stock-video category/zone page, so we never suggest a keyword that yields
 * zero results when applied (DEV-5395).
 *
 * - Exact-keyword-match categories: `filterBy` (a Typesense `filter_by`
 *   clause) restricts facet counts to videos carrying a category keyword —
 *   which is exactly how the grid is filtered in that mode.
 * - Vector categories/zones: `embedding` + `distanceThreshold` restrict facet
 *   counts to the same vector neighbourhood the grid renders. Faceting over
 *   keyword matches would be wrong here because zone content is defined by
 *   embedding proximity, not by carrying the literal category keyword.
 *
 * `key` is a stable, lightweight identity for the scope, used in the React
 * Query cache key (the embedding array itself is far too large to hash).
 */
export interface CategorySuggestionScope {
  distanceThreshold?: number;
  embedding?: number[];
  filterBy?: string;
  key: string;
}
